module.exports = __webpack_public_path__ + "img/matthew.b05bca43.jpg";